import { Component } from '@angular/core';

@Component({
  selector: 'vat-analysis-engagement',
  imports: [],
  templateUrl: './analysis-engagement.html',
  styleUrl: './analysis-engagement.css',
})
export class AnalysisEngagement {

}
